import { useEffect } from 'react';
import { noop } from 'lodash';

// Note: This hook will be extracted into Orca.
const useObserver = ({ observableRef = null, onObserve = noop, onNotSupported = noop }) => {

    useEffect(() => {

        const initObserver = () => {
            if (!window.IntersectionObserver) {
                onNotSupported();
                return;
            }

            if (!observableRef) {
                throw new Error('observableRef is not defined');
            }

            const observeTarget = observableRef.current;
            const observer = new IntersectionObserver((entries) => {
                if (entries[0].intersectionRatio <= 0) {
                    return;
                }

                onObserve();
                observer.unobserve(observeTarget);
            });

            observer.observe(observeTarget);
        };

        initObserver();
    }, [onObserve, observableRef, onNotSupported]);

    return observableRef;
};

export default useObserver;
